export const numberOfTruncatedResultsToShow = 4;
